export default __webpack_public_path__ + "static/label-do-b9027cc11491d17322095a300aaad9d53a2e088958e004af08b484607703739b.png";